import CONSTANTES from "../constantes";

export const reducerUsuarios = (state = { usuarios: [] }, action) => {
  switch (action.type) {
    case CONSTANTES.OBTENER_USUARIOS:
      return { ...state, usuarios: action.usuarios }
    case CONSTANTES.ADD_USUARIO:
      state.usuarios.unshift(action.usuario)
      return { ...state, usuarios: [...state.usuarios] }

    case CONSTANTES.EDIT_USUARIO:
      if (action.usuario) {
        let id = action.usuario.id
        var indexUsuario = state.usuarios.findIndex(item => item.id === id)
        state.usuarios.splice(indexUsuario, 1, action.usuario)
      }
      return { ...state, usuarios: [...state.usuarios] }
    case CONSTANTES.SUBIR_FOTO_USAURIO:
      console.log(action.imagen)
      return { ...state, fotoUsuario: action.imagen }
    default:
      return state
  }
}

  